import { memo } from 'react';
import { LegacyButton } from './LegacyButton';
import { stripeStore } from '~/lib/stores/stripe';

export const UpdateStripeProducts = memo(() => {
  return (
    <LegacyButton onClick={stripeStore.openModalToEditProducts} variant="primary">
      Select Products
    </LegacyButton>
  );
});
